// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".timer {\r\n  font-size: 40px;\r\n  color: white;\r\n  margin-top: -100px;\r\n}\r\n", "",{"version":3,"sources":["webpack://./src/sprint/Timer/timer.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".timer {\r\n  font-size: 40px;\r\n  color: white;\r\n  margin-top: -100px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
